/**
 * Get data from API via fetch w/ POST
 * TODO: Possibly cache fetch request w/ components/ajax-cacher
 * @param  {String} url  URL of data you are posting to`
 * @param  {Object} data Object containing data to POST
 * @return {Object}      Object containing request response
 */
const postData = (url, data) =>
  fetch(url, {
    body: JSON.stringify(data),
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    method: 'POST',
    mode: 'cors',
  }).then((response) => {
    if (response.ok) {
      return response.text();
    }
    throw new Error('Network response was not ok.');
  });

export default postData;
